import React, { useContext, useEffect, useMemo } from 'react';

import { makeCSS } from '@cube3/cubicle/src/utils/makeCSS';
import { NavItem } from '@cube3/cubicle/src/core/atoms/Navigation/NavItem';
import { mediaQueueContext } from '../MediaQueue/context/mediaQueueContext';
import { useUploads } from '@cube3/state/src/redux/components/Hooks/useUploads';
import { NavDrawerItem } from './NavigationDrawer';
import { useNavigationItem } from './hooks/useNavigationItem';

interface LinkerProps extends NavDrawerItem {
  admin?: boolean;
  onClick?: () => void;
}

interface LinkerGroup {
  groupName: string;
  items: LinkerProps[];
  alignBottom?: boolean;
  title?: string;
}

interface NavDrawerProperties {
  isAdmin: boolean;
  navigationItems: LinkerGroup[];
  backUrl?: string;
  // failedStatus?: null | 'failed';
}

const useCSS = makeCSS(({ theme }) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 12,
      paddingBottom: 20
    }
  };
});

const QuickNavigationDrawer: React.FC<NavDrawerProperties> = React.memo(
  (props) => {
    const { navigationItems, isAdmin, backUrl } = props;
    const classes = useCSS();

    const { handleItemClick, isActive } = useNavigationItem(backUrl);

    //failed status
    const { status, handleStatusChange } = useContext(mediaQueueContext);
    const { allUploads } = useUploads();

    const failed = useMemo(() => {
      return allUploads.filter((u) => u.failed || (u.active && !u.tusUpload));
    }, [allUploads]);
    useEffect(() => {
      if (failed.length) {
        handleStatusChange({
          status: 'failed',
          message: null
        });
      } else {
        handleStatusChange({
          status: null,
          message: null
        });
      }
    }, [failed, handleStatusChange]);

    return (
      <div className={classes.container}>
        {navigationItems.map((g) => (
          <>
            {g.items.map((i, idx) =>
              i.admin && !isAdmin ? null : (
                <NavItem
                  quickNavigation={true}
                  item={i}
                  isActive={isActive(i)}
                  key={i.linkTitle + idx}
                  onClick={(ev?: React.MouseEvent) => handleItemClick(i, ev)}
                  failedStatus={status === 'failed'}
                />
              )
            )}
          </>
        ))}
      </div>
    );
  }
);

export default QuickNavigationDrawer;
